export const about = '/About';
export const account = '/Account';
export const billing = '/Billing';
export const editBillableItem = '/EditBillableItem';
export const createAccount = '/CreateAccount';
export const createPatient = '/CreatePatient';
export const createRecord = '/CreateRecord';
export const createSite = '/CreateSite';
export const createSponsor = '/CreateSponsor';
export const createStudy = '/CreateStudy';
export const forgotPassword = '/ForgotPassword';
export const linkSites = '/LinkSites';
export const linkSponsor = '/LinkSponsor';
export const linkStudies = '/LinkStudies';
export const manageAccounts = '/ManageAccounts';
export const managePatients = '/ManagePatients';
export const manageSites = '/ManageSites';
export const manageSponsors = '/ManageSponsors';
export const manageStudies = '/ManageStudies';
export const home = '/';
export const homeEmailConfirm = '/?EmailConfirm';
export const homeEmailReset = '/?EmailReset';
export const homeResetSuccess = '/?ResetSuccess';
export const patient = '/Patient';
export const resetPassword = '/ResetPassword';
export const selectPatient = '/SelectPatient';
export const dashboard = '/Dashboard';
export const selectRecord = '/SelectRecord';
export const viewRecord = '/Record';
export const selectSite = '/SelectSite';
export const selectSponsor = '/SelectSponsor';
export const selectStudy = '/SelectStudy';
export const selectStudySite = '/SelectStudySite';
export const settings = '/Settings';
export const site = '/Site';
export const sponsor = '/Sponsor';
export const study = '/Study';



// WEBPACK FOOTER //
// ./src/data/Paths.js